import emailjs from '@emailjs/browser';

// Asegurar que este archivo es tratado como un módulo
export {};

// Configuración de EmailJS desde variables de entorno
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'TU_PUBLIC_KEY_AQUI';
const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'TU_SERVICE_ID_AQUI';
const EMAILJS_TEMPLATE_CONTACT_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_CONTACT_ID || 'TU_TEMPLATE_CONTACT_ID_AQUI';
const EMAILJS_TEMPLATE_QUOTE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_QUOTE_ID || 'TU_TEMPLATE_QUOTE_ID_AQUI';
const EMAIL_TO = process.env.REACT_APP_EMAIL_TO || 'ventas@atomcorporations.com';

// Inicializar EmailJS
export const initEmailJS = () => {
  emailjs.init(EMAILJS_PUBLIC_KEY);
};

// Interfaz para los datos del formulario de contacto
export interface ContactFormData {
  name: string;
  email: string;
  phone?: string;
  company?: string;
  industry?: string;
  service?: string;
  message: string;
}

// Interfaz para los datos del formulario de cotización
export interface QuoteFormData {
  name: string;
  email: string;
  phone: string;
  company?: string;
  industry?: string;
  service?: string;
  productType?: string;
  quantity?: string;
  specifications?: string;
  urgency?: string;
  message?: string;
}

// Función para enviar correo de contacto
export const sendContactEmail = async (formData: ContactFormData): Promise<boolean> => {
  try {
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone || 'No proporcionado',
      company: formData.company || 'No proporcionada',
      industry: formData.industry || 'No especificada',
      service: formData.service || 'No especificado',
      message: formData.message,
      to_email: EMAIL_TO,
      reply_to: formData.email
    };

    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_CONTACT_ID,
      templateParams
    );

    return response.status === 200;
  } catch (error) {
    console.error('Error al enviar correo de contacto:', error);
    return false;
  }
};

// Función para enviar correo de cotización
export const sendQuoteEmail = async (formData: QuoteFormData): Promise<boolean> => {
  try {
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone,
      company: formData.company || 'No proporcionada',
      industry: formData.industry || 'No especificada',
      service: formData.service || 'No especificado',
      product_type: formData.productType || 'No especificado',
      quantity: formData.quantity || 'No especificada',
      specifications: formData.specifications || 'No especificadas',
      urgency: formData.urgency === 'urgente' ? 'Urgente (24-48 horas)' : 'Normal (3-5 días hábiles)',
      message: formData.message || 'No especificado',
      to_email: EMAIL_TO,
      reply_to: formData.email
    };

    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_QUOTE_ID,
      templateParams
    );

    return response.status === 200;
  } catch (error) {
    console.error('Error al enviar correo de cotización:', error);
    return false;
  }
};

// Función para validar formato de email
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};